// removed by extract-text-webpack-plugin
module.exports = {"btn-actions":"btn-actions","avatar":"avatar"};


//////////////////
// WEBPACK FOOTER
// ./assets/styles/global.css
// module id = ./assets/styles/global.css
// module chunks = 0